export default __webpack_public_path__ + "static/media/agencyLaptop-Side.b7023d74.webp";